
const digest = '18df374589d98855dbd678a580a45d59832c68d5f2e5ed498213a0fffdd0c7a8';
const css = `._image_1tyq0_1 {
  display: inline-block;
  position: relative;
  max-width: 100%;
  text-align: center;
}

._imageInline_1tyq0_8 {
  display: inline-block;
  margin: 0.2em;
  max-width: 100%;
}

._imageBlock_1tyq0_14 {
  display: block;
  text-align: center;
  margin: 0.2em;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"image":"_image_1tyq0_1","imageInline":"_imageInline_1tyq0_8","imageBlock":"_imageBlock_1tyq0_14"};
export { css, digest };
  